<template>
    <div class="main-content" id="insights">
        <PageTitle main-title="Insights" sub-title="Get insights of your ambassadors and reach" av-icon="stats">
            <template v-slot:page-title-actions>
                <div class="float-right">
                    <Input type="select" width="inline">
                        <option>Default Apostle report</option>
                        <option>My first report</option>
                        <option>+ Create new report</option>
                    </Input>
                    <Button variant="neutral"><svgicon name="plus" /></Button>
                    <Button variant="neutral"><svgicon name="edit" /></Button>
                </div>
            </template>
        </PageTitle>
        <div class="row">
            <div class="col-md-9">
                <div class="row statistics-row">
                    <div class="col-md-3">
                        <Card card-title="Suggestions">
                            <div class="statistic-headline">531</div>
                            <div class="statistic-tagline good">+22%</div>
                        </Card>
                    </div>
                    <div class="col-md-3">
                        <Card card-title="Shares">
                            <div class="statistic-headline">263</div>
                            <div class="statistic-tagline bad">-13%</div>
                        </Card>
                    </div>
                    <div class="col-md-3">
                        <Card card-title="Potential reach">
                            <div class="statistic-headline">49841K</div>
                            <div class="statistic-tagline good">+5%</div>
                        </Card>
                    </div>
                    <div class="col-md-3">
                        <Card card-title="Earned Media Value">
                            <div class="statistic-headline">€135M</div>
                            <div class="statistic-tagline warning">-2%</div>
                        </Card>
                    </div>
                </div>
                <div class="row statistics-row">
                    <div class="col">
                        <Card card-title="Activity">
                            <template v-slot:card-actions>
                                <ButtonGroup><Button variant="default">Shares</Button><Button variant="neutral">Inputs</Button></ButtonGroup>
                            </template>
                            <component v-bind:is="selectedActivity"></component>
                            <div class="row more-info-row">
                                <div class="col-md-12">
                                    <Accordion>
                                        <template v-slot:accordion-title>
                                            User information
                                        </template>
                                        <template v-slot:accordion-subtitle>
                                            insights per user
                                        </template>
                                        <div class="width-100 relative">
                                            Table with users
                                        </div>
                                    </Accordion>
                                    <Accordion>
                                        <template v-slot:accordion-title>
                                            Post information
                                        </template>
                                        <template v-slot:accordion-subtitle>
                                            insights per post
                                        </template>
                                        <div class="width-100 relative">
                                            Table with posts
                                        </div>
                                    </Accordion>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                <div class="row statistics-row">
                    <div class="col-md-6">
                        <Card card-title="Best time to suggest">
                            <template v-slot:card-actions>

                            </template>
                            <div class="row">
                                <div class="col-md-12">
                                    <BubbleChart :chart-data="timeToShareDataCollection" :options="options" :width="1000"></BubbleChart>
                                    <!--<button @click="fillData()">Randomize</button>-->
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div class="col-md-6">
                        <Card card-title="Sharing channels">
                            <template v-slot:card-actions>
                            </template>
                            <div class="row">
                                <div class="col-md-8 offset-md-2">
                                    <DoughnutChart :chart-data="dougnutData" :options="doughnutOptions"></DoughnutChart>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
            <div class="col-md-3" id="filter-row">
                <Card card-title="Filter insights">
                    <div class="row">
                        <div class="col-md-12">
                            <p>Filter insights by period and/or by groups, users, themes and more.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <Input placeholder="Starting date"/>
                        </div>
                        <div class="col-md-6">
                            <Input placeholder="End date"/>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-12">
                            <Input type="" label="User(s)" placeholder="All" />
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-12">
                            <Input type="" label="Post(s)" placeholder="All" />
                        </div>
                    </div>
                </Card>
                <Card card-title="Choose parameters">
                    <p>Choose elements and drag them to the left in order to add statistics.</p>
                    <Card>Leaderboard</Card>
                    <Card>User activity</Card>
                    <Card>Shared posts</Card>
                    <Card>Clicks</Card>
                    <Card>Theme activity</Card>
                    <Card>Social channel activity</Card>
                    <Card>Group activity</Card>
                    <Card>Leaderboard</Card>
                </Card>
            </div>
        </div>
    </div>
</template>
<script>
    import Card from "../../components/Card/Card";
    import PageTitle from "../../components/Pagetitle/Pagetitle";
    import Label from "../../components/Label/Label";
    import Button from "../../components/Button/Button";
    import ButtonGroup from "../../components/ButtonGroup/ButtonGroup";
    import Tabs from "../../components/Tabs/Tabs";
    import Modal from "../../components/Modal/Modal";
    import Input from "../../components/Input/Input";
    import BubbleChart from "../../components/Charts/BubbleChart";
    import BarChart from "../../components/Charts/BarChart";
    import Accordion from "../../components/Accordion/Accordion";
    import ShareActivity from "../../views/Insights/components/ShareActivity";
    import DoughnutChart from "../../components/Charts/DoughnutChart";

    export default {
        name: 'Insights',
        components: {
            PageTitle,
            Card,
            Label,
            Button,
            Tabs,
            Modal,
            Input,
            BubbleChart,
            BarChart,
            ButtonGroup,
            Accordion,
            ShareActivity,
            DoughnutChart
        },
        props: [],
        data () {
            return {

                timeToShareDataCollection: null,
                options: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0.05)",
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0.02)",
                            }
                        }]
                    }
                },
                selectedActivity: ShareActivity,
                doughnutOptions: {
                    responsive: true,
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                drawBorder: false,
                                display: false
                            }
                        }],
                        yAxes: [{
                            display: false,
                            gridLines: {
                                drawBorder: false,
                                display: false
                            }
                        }]
                    }
                },
                dougnutData: {
                    labels: ['Instagram', 'Facebook', 'Twitter', 'Linkedin'],
                    datasets: [
                        {
                            backgroundColor: ['#DD2A7B', '#3B5998', '#5B9EFF', '#0E76A8'],
                            data: [20, 20, 30, 40]
                        }
                    ]
                }
            }
        },
        computed: {

        },
        mounted () {
            this.fillData()
        },
        methods: {
            fillData () {
                this.activityDataCollection = {
                    labels: ['11-06', '12-06', '13-06', '14-06', '15-06', '16-06', '17-06'],
                    datasets: [
                        {
                            label: 'Suggestions for ambassadors',
                            borderColor: "#4dc0b5",
                            backgroundColor: "#4dc0b5",
                            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                        }, {
                            label: 'Suggestions shared',
                            borderColor: '#ffb75d',
                            backgroundColor: "#ffb75d",
                            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                        }
                    ]
                },
                this.timeToShareDataCollection = {
                    labels: ['11', '22', '13-06', '14-06', '15-06', '16-06', '17-06'],
                    datasets: [
                        {
                            label: 'Best time to share',
                            borderColor: "#0070D2",
                            backgroundColor: "rgba(0,112,210,0)",
                            data: [{x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}, {x: this.getRandomInt(), y: this.getRandomInt()}]
                        }
                    ]
                }
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }
</script>
<style src="./Insights.scss" scoped lang="scss"></style>

